"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncUtils = void 0;
class AsyncUtils {
    static delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    static sleep(ms) {
        return new Promise((res) => setTimeout(res, ms));
    }
    static isFunction(v) {
        return typeof v === "function";
    }
    /**
     * Waits for window[methodName] to become a function, then calls it.
     * Returns true if the call succeeded, false if not found / timed out / call threw.
     */
    static waitForWindowMethodAndCall(methodName, ...argsAndMaybeOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const last = argsAndMaybeOptions[argsAndMaybeOptions.length - 1];
            const hasOptions = last &&
                typeof last === "object" &&
                ("intervalMs" in last ||
                    "maxAttempts" in last ||
                    "timeoutMs" in last ||
                    "debug" in last);
            const options = hasOptions ? last : {};
            const args = (hasOptions
                ? argsAndMaybeOptions.slice(0, -1)
                : argsAndMaybeOptions);
            const intervalMs = (_a = options.intervalMs) !== null && _a !== void 0 ? _a : 50;
            const maxAttempts = (_b = options.maxAttempts) !== null && _b !== void 0 ? _b : 100;
            const deadline = typeof options.timeoutMs === "number" ? Date.now() + options.timeoutMs : null;
            let attempts = 0;
            while (true) {
                const candidate = window[methodName];
                if (this.isFunction(candidate)) {
                    try {
                        candidate(...args);
                        return true;
                    }
                    catch (err) {
                        if (options.debug) {
                            console.warn(`[AsyncUtils.waitForWindowMethodAndCall] "${String(methodName)}" threw:`, err);
                        }
                        return false;
                    }
                }
                attempts++;
                if (deadline !== null) {
                    if (Date.now() >= deadline)
                        return false;
                }
                else {
                    if (attempts >= maxAttempts)
                        return false;
                }
                yield this.sleep(intervalMs);
            }
        });
    }
}
exports.AsyncUtils = AsyncUtils;
